import { accessCookie } from './lib/cookie'

accessCookie('ivyplace')

$('.js-tel-ivyplace').tewrap({
  phoneNumber: '03-6415-3232'
})



// WEBPACK FOOTER //
// ./src/js/ivyplace.js